module.exports = __webpack_public_path__ + "media/images/logo-2b8faf6a2fc9fa32aaaf693a7db1b995.svg";